module.exports = {"iconDefault":"7a869a","iconDark":"6b778c"}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/data/colors.json
// module id = SXGo
// module chunks = 24